import { Controller } from "@hotwired/stimulus"

// The refusal shown after a round could not be closed (#8739).
//
// Opened as a MODAL: a `<dialog open>` is a plain box in the page, with no
// backdrop, and neither Escape nor a click outside closes it (QA 07/10).
//
// And the refusal belongs to the request that produced it: `close_error` is
// dropped from the address as soon as the dialog is shown, or every reload and
// every shared link showed it again, even after the incidents were declared.
// On display rather than on close — a closing dialog's `close` event is not
// dispatched while the page is hidden, and the address must not depend on it.
export default class extends Controller {
  static values = { param: String }

  connect() {
    if (!this.element.open) this.element.showModal()
    this.forget()
  }

  // A click on the backdrop targets the dialog itself — but so does a click in
  // its own padding, hence the test on where the click landed.
  closeOnBackdrop(event) {
    if (event.target !== this.element) return

    const box = this.element.getBoundingClientRect()
    const inside = event.clientX >= box.left && event.clientX <= box.right &&
      event.clientY >= box.top && event.clientY <= box.bottom
    if (!inside) this.element.close()
  }

  forget() {
    const url = new URL(window.location.href)
    url.searchParams.delete(this.paramValue)
    window.history.replaceState(window.history.state, "", url)
  }
}
